import React from 'react';

const Beneficio = ({datos}) => {
	return (
		<article className='beneficio'>
			<img src={datos.img} alt={datos.imgalt} />
			<h3 className='beneficio__title'>{datos.title}</h3>
			<p className='beneficio__parrafo'>{datos.parrafo}</p>
		</article>
	);
};

Beneficio.defaultProps = {
	datos: {
		img: './img/time.svg',
		imgalt: 'alt',
		title: 'Ahorra algo',
		parrafo: 'este es el parrafo',
	},
};

export default Beneficio;
